import React from 'react';
import { FaChevronDown } from 'react-icons/fa6';

export type AccordionBg = 'transparent' | 'neutralBG' | 'neutralBG2';

interface AccordionProps {
  header: React.ReactNode;
  children: React.ReactNode;
  isOpen: boolean;
  onToggle: () => void;
  chevronPosition?: 'left' | 'right';
  bg?: AccordionBg;
  className?: string;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  disableHover?: boolean;
}

const bgClass = {
  transparent: 'bg-transparent',
  neutralBG: 'bg-neutralBG dark:bg-neutralBG-dark',
  neutralBG2: 'bg-neutralBG2 dark:bg-neutralBG2-dark',
};

export const Accordion: React.FC<AccordionProps> = ({
  header,
  children,
  isOpen,
  onToggle,
  chevronPosition = 'left',
  bg = 'neutralBG2',
  className = '',
  onMouseEnter,
  onMouseLeave,
  disableHover = false,
}) => {
  return (
    <div
      className={`w-full ${className}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <span
        className={`flex w-full items-center justify-between rounded-md p-2 text-left font-medium text-neutralText transition-colors duration-150 focus:outline-none ${bgClass[bg]} ${isOpen && !disableHover ? (bg === 'neutralBG2' ? 'dark:bg-neutralBG2-hover-dark bg-neutralBG2-hover' : '') : ''}`}
        onClick={onToggle}
        role="button"
        tabIndex={0}
        aria-expanded={isOpen}
      >
        {chevronPosition === 'left' && (
          <FaChevronDown
            className={`mr-2 fill-neutralText text-sm transition-transform dark:fill-neutralText-dark ${isOpen ? 'rotate-180' : ''}`}
          />
        )}
        <div className="flex min-w-0 flex-1 items-center">{header}</div>
        {chevronPosition === 'right' && (
          <FaChevronDown
            className={`fill-neutralText text-sm transition-transform dark:fill-neutralText-dark ${isOpen ? 'rotate-180' : ''}`}
          />
        )}
      </span>
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[1000px] py-2 opacity-100' : 'max-h-0 opacity-0'}`}
      >
        <div>{children}</div>
      </div>
    </div>
  );
};
